import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'state';

export interface BreadcrumbItem {
  label: string;
  url: string;
}

export interface BreadcrumbState {
  items: BreadcrumbItem[]
}

export const initialState: BreadcrumbState = {
  items: [],
};

export const breadcrumbSlice = createSlice({
  name: 'breadcrumb',
  initialState,
  reducers: {
    setBreadcrumbsAction: (state, action: PayloadAction<BreadcrumbItem[]>) => {
      state.items = action.payload;
    },
    clearBreadcrumbsAction: (state) => {
      state.items = [];
    },
  },
});

export const {
  setBreadcrumbsAction,
  clearBreadcrumbsAction,
} = breadcrumbSlice.actions;

export const breadcrumbsSelector = (state: RootState):
  BreadcrumbItem[] => state.breadcrumb.items;
